import React, { useMemo } from 'react';

import { Reconnect } from 'src/federation/Reconnect';

import {
  getMonthlySalesReportTableProps,
  MonthlySalesReportTableProps,
} from './monthlySalesReportTableProps';

export const ReportTable = ({
  venueId,
  reportData,
  employeeFilter,
  selectedChannel,
}: MonthlySalesReportTableProps) => {
  const props = useMemo(
    () => getMonthlySalesReportTableProps({ venueId, employeeFilter, selectedChannel, reportData }),
    [venueId, reportData, employeeFilter, selectedChannel],
  );

  return <Reconnect name="ReportTable" props={props} />;
};
